import { Helpers } from '@app/shared/helpers';
import { BaseModel, BaseModelInterface } from '@app/abstracts';
import { User, UserInterface } from '../user/user';
import {
	FormationThematique,
	FormationThematiqueInterface,
} from '../formation-thematique/formation-thematique';
export interface AttestationPresenceThematiqueInterface
	extends BaseModelInterface {
	created_at: number | Date;
	owner: string | User | UserInterface;
	thematique: string | FormationThematique | FormationThematiqueInterface;
	date: number | Date;
	signature: string;
	owner_type: string;
	delay?: number;
}
export interface AttestationPresenceThematiquePayload {
	owner: string | User | UserInterface;
	thematique: string | FormationThematique | FormationThematiqueInterface;
	date: number | Date;
	signature: string;
	owner_type: string;
	delay?: number;
}
type AttestationPresenceThematiquePayloadKey =
	keyof AttestationPresenceThematiquePayload;
export class AttestationPresenceThematique extends BaseModel<
	AttestationPresenceThematiqueInterface,
	AttestationPresenceThematiquePayload
> {
	/** Short function to get label of instance */
	getLabel(): string {
		return this.props._id;
	}
	/** Denotes if the instance of owner has been populated */
	ownerExists(): boolean {
		return (
			!!this.props &&
			this.props.owner instanceof User &&
			this.props.owner.exists()
		);
	}
	/** Denotes if the instance of thematique has been populated */
	thematiqueExists(): boolean {
		return (
			!!this.props &&
			this.props.thematique instanceof FormationThematique &&
			this.props.thematique.exists()
		);
	}
	/** Populate the current instance from an object */
	fromObject(object: AttestationPresenceThematiqueInterface): void {
		this.props = Object.assign({}, object);
		this.props.created_at = Helpers.convertToDate(this.props.created_at);
		this.props.date = Helpers.convertToDate(this.props.date);
		if (typeof this.props.owner === 'object') {
			this.props.owner = new User(<UserInterface>this.props.owner);
		}
		if (typeof this.props.thematique === 'object') {
			this.props.thematique = new FormationThematique(
				<FormationThematiqueInterface>this.props.thematique
			);
		}
		this.next();
	}
	/** Convert the current instance to an object */
	toObject(): AttestationPresenceThematiqueInterface {
		const props = Object.assign({}, this.props);
		props.created_at = Helpers.convertToTimestamp(props.created_at);
		props.date = Helpers.convertToTimestamp(props.date);
		if (props.owner instanceof User) {
			props.owner = props.owner.toObject();
		}
		if (props.thematique instanceof FormationThematique) {
			props.thematique = props.thematique.toObject();
		}
		return props;
	}
	/** Convert an instance to an object to be sent to the API */
	toPayload(): AttestationPresenceThematiquePayload {
		const raw = this.toObject();
		const allowed = this.allowedKeys();
		const payload = Object.keys(raw)
			.filter((key) => allowed.includes(<any>key))
			.reduce((o, k) => {
				o[k] = raw[k];
				return o;
			}, {} as AttestationPresenceThematiqueInterface);
		payload.owner = payload.owner ? this.extractId(payload.owner) : null;
		payload.thematique = payload.thematique
			? this.extractId(payload.thematique)
			: null;
		payload.date = <number>payload.date;
		return payload as AttestationPresenceThematiquePayload;
	}
	/** List allowed keys to be sent to the API */
	protected allowedKeys(): AttestationPresenceThematiquePayloadKey[] {
		return [
			'owner',
			'thematique',
			'date',
			'signature',
			'owner_type',
			'delay',
		];
	}
}
